var map = {
	"./Asset 1.svg": 135,
	"./blue-lion-dance1.jpg": 68,
	"./chinese-new-year-100.jpg": 136,
	"./chinese-new-year-100.png": 137,
	"./cnspeachchairman.jpg": 138,
	"./committee.jpg": 139,
	"./donate@1.5x-100.jpg": 71,
	"./enspeachchairman.jpg": 140,
	"./fb-icon.svg": 72,
	"./gallery@1.5x-100.jpg": 69,
	"./gmail-icon.svg": 73,
	"./hero-dragon-100.jpg": 141,
	"./hero-dragon-50.jpg": 142,
	"./hero-image@2x-100.jpg": 19,
	"./logo.svg": 38,
	"./sanya@1.5x-100.jpg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;